module.exports = __webpack_public_path__ + "img/type1_check1.65741a19.png";